var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3 bg-secondary-1" },
    [
      _c("validation-observer", { ref: "formValidator" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "row mx-1" },
              [
                _vm._l(_vm.mainFilters, function(filter) {
                  return _c(
                    "div",
                    {
                      key: filter.name,
                      class: `${filter.class || "col"} col-sm my-1`
                    },
                    [
                      _c("validation-provider", {
                        attrs: { rules: filter.validations },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c(filter.component, {
                                    tag: "component",
                                    attrs: {
                                      "class-container": filter.classContainer,
                                      clearable: filter.clearable,
                                      "custom-error-msg":
                                        filter.error && errors[0]
                                          ? filter.error
                                          : errors[0],
                                      disabled: _vm.disabled(filter),
                                      error:
                                        filter.error && errors[0]
                                          ? filter.error
                                          : errors[0],
                                      fieldkey: filter.fieldKey,
                                      fieldname: filter.fieldName,
                                      i: filter.icon,
                                      icon: filter.icon,
                                      "is-inline": filter.isInline,
                                      label: filter.label,
                                      "left-icon": filter.leftIcon,
                                      "mask-type": filter.maskType,
                                      masked:
                                        filter.masked != undefined
                                          ? filter.masked
                                          : false,
                                      options: filter.options,
                                      placeholder: filter.placeholder,
                                      type: filter.type,
                                      variant: filter.variant
                                    },
                                    on: {
                                      "update:customErrorMsg": function(
                                        $event
                                      ) {
                                        return _vm.$set(
                                          filter.error && errors[0]
                                            ? filter.error
                                            : errors,
                                          0,
                                          $event
                                        )
                                      },
                                      "update:custom-error-msg": function(
                                        $event
                                      ) {
                                        return _vm.$set(
                                          filter.error && errors[0]
                                            ? filter.error
                                            : errors,
                                          0,
                                          $event
                                        )
                                      },
                                      change: function($event) {
                                        return _vm.changeFilter(filter)
                                      },
                                      input: function($event) {
                                        return _vm.changeFilter(filter)
                                      }
                                    },
                                    model: {
                                      value: _vm.value[filter.name],
                                      callback: function($$v) {
                                        _vm.$set(_vm.value, filter.name, $$v)
                                      },
                                      expression: "value[filter.name]"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                }),
                _vm._t("default")
              ],
              2
            )
          ]),
          _vm.searchText
            ? _c("div", { staticClass: "col-md-3 col-lg-2 col-sm my-1" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-md-end justify-content-sm-start"
                  },
                  [
                    _vm.showAdvancedOptions
                      ? _c("action-button", {
                          staticClass: "mx-3 pl-3",
                          class: { transparent: !_vm.advanced },
                          attrs: { i: "fal fa-sliders-v", variant: "orange" },
                          on: {
                            click: function($event) {
                              _vm.advanced = !_vm.advanced
                            }
                          }
                        })
                      : _vm._e(),
                    _c("action-button", {
                      class: { "mx-3": !_vm.showAdvancedOptions },
                      attrs: {
                        disabled: _vm.disabledSearch,
                        i: _vm.searchIcon,
                        text: _vm.searchText,
                        variant: "success"
                      },
                      on: { click: _vm.search }
                    })
                  ],
                  1
                )
              ])
            : _vm._e()
        ]),
        _vm.advanced
          ? _c("div", { staticClass: "col-md-12" }, [
              _c("div", { staticClass: "row py-3" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-flex align-items-center color-gray-8 font-14",
                      class: _vm.$style.separator
                    },
                    [_vm._v(" FILTROS ")]
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm.advanced
          ? _c(
              "div",
              { staticClass: "row mx-1" },
              [
                _vm.$slots.header_advanced
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [_vm._t("header_advanced")],
                      2
                    )
                  : _vm._e(),
                _vm._l(_vm.advancedFilters, function(filter) {
                  return _c(
                    "div",
                    {
                      key: filter.name,
                      class: `${filter.class || "col"} col-sm my-1`
                    },
                    [
                      _c("validation-provider", {
                        attrs: { rules: filter.validations },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c(filter.component, {
                                    tag: "component",
                                    attrs: {
                                      "class-container": filter.classContainer,
                                      clearable: filter.clearable,
                                      "custom-error-msg":
                                        filter.error && errors[0]
                                          ? filter.error
                                          : errors[0],
                                      disabled: _vm.disabled(filter),
                                      error:
                                        filter.error && errors[0]
                                          ? filter.error
                                          : errors[0],
                                      fieldkey: filter.fieldKey,
                                      fieldname: filter.fieldName,
                                      i: filter.icon,
                                      icon: filter.icon,
                                      "is-inline": filter.isInline,
                                      label: filter.label,
                                      "left-icon": filter.leftIcon,
                                      "mask-type": filter.maskType,
                                      masked:
                                        filter.masked != undefined
                                          ? filter.masked
                                          : false,
                                      name:
                                        filter.componentName != undefined
                                          ? filter.componentName
                                          : "",
                                      options: filter.options,
                                      placeholder: filter.placeholder,
                                      type: filter.type,
                                      variant: filter.variant
                                    },
                                    on: {
                                      "update:customErrorMsg": function(
                                        $event
                                      ) {
                                        return _vm.$set(
                                          filter.error && errors[0]
                                            ? filter.error
                                            : errors,
                                          0,
                                          $event
                                        )
                                      },
                                      "update:custom-error-msg": function(
                                        $event
                                      ) {
                                        return _vm.$set(
                                          filter.error && errors[0]
                                            ? filter.error
                                            : errors,
                                          0,
                                          $event
                                        )
                                      },
                                      change: function($event) {
                                        return _vm.changeFilter(filter)
                                      },
                                      input: function($event) {
                                        return _vm.changeFilter(filter)
                                      }
                                    },
                                    model: {
                                      value: _vm.value[filter.name],
                                      callback: function($$v) {
                                        _vm.$set(_vm.value, filter.name, $$v)
                                      },
                                      expression: "value[filter.name]"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                }),
                _vm._t("advanced")
              ],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }